module.exports = __webpack_public_path__ + "static/media/volar-regional.6d773463.png";